<template>
  <div class="import-tool">
    <Modal v-model="visible" title="批量导入（新增）费用" :mask-closable="false" width="500" :footer-hide="true" class="my-modal top import-tool-modal2">
      <div style="margin-top: 10px;">
        操作步骤：<br />
        1、下载模板，根据模板要求填充费用明细。<br />
        2、导入Excel。<br /><br />
        <p class="text2">
          注意：本功能仅支持<span class="text3">批量新增</span
          >保单的费用记录及其结算情况，不能修改已有的费率，如需修改请到财务管理结算单里修改/批量修改。
        </p>
        单次最多导入1000条数据。
      </div>

      <div class="ivu-modal-footer">
        <Button type="primary" @click="download" ghost>下载模板</Button>
        <Upload
          ref="upload"
          v-if="data.uploadUrl"
          :show-upload-list="false"
          class="upload-btn"
          :max-size="2048"
          :data="data.uploadParams"
          :before-upload="handleBeforeUpload"
          :action="data.uploadUrl"
        >
          <Button type="primary" :loading="loading">导入</Button>
        </Upload>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      columns: [
        {
          title: '行号',
          key: 'row',
          width: 100,
          align: 'center'
        },
        {
          title: '错误原因',
          key: 'content',
          align: 'center',
          minWidth: 100
        }
      ],
      fileFormat: ['xls', 'xlsx', 'XLS', 'XLSX'],
      visible: false,
      loading: false,
      data: {}
    };
  },
  methods: {
    open(data = {}) {
      this.data = data;
      this.loading = false;
      this.visible = true;
    },
    download() {
      this.$units.downloadFile(this.data.template, this.data.params, 'GET', this.data.templateName);
    },
    handleBeforeUpload(file) {
      let arr = file.name.split('\.');
      let format = arr[arr.length - 1];
      if (!this.fileFormat.includes(format)) {
        this.$notice.msg('请上传' + this.fileFormat.join(',') + '格式的文件');
        return false;
      }
      let formData = new FormData();
      formData.append('file', file);
      const params = this.data.uploadParams;
      if (params) {
        for (const key in params) {
          if (Object.hasOwnProperty.call(params, key)) {
            const element = params[key];
            formData.append(key, element);
          }
        }
      }
      this.loading = true;
      this.$http({
        type: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        url: this.data.uploadUrl,
        data: formData
        // apiPermissionCode:this.data.apiPermissionCode
      })
        .then(res => {
          if (res.data.errorList) {
            const successNum = res.data.successList && res.data.successList.length;
            const errorNum = res.data.errorList && res.data.errorList.length;
            let text = `系统已成功导入${successNum}条数据`;
            if (errorNum) {
              text = text + `，存在${errorNum}条数据未导入`;
              if (this.data.errorUrl) {
                this.$units.downloadFile(
                  this.data.errorUrl,
                  {
                    errorList: res.data.errorList
                  },
                  'POST'
                );
              }
              this.$notice.error(text);
            } else {
              this.visible = false;
              this.$notice.success(text);
            }
            this.$emit('success');
          } else {
            if (res.data.errorCount) {
              if (res.data.fileUrl) {
                this.$units.downloadFile('/buz/productBase/downloadFile', { fileUrl: res.data.fileUrl }, 'GET');
              }
              this.$notice.error(`系统已成功导入${res.data.successCount}条数据，存在${res.data.errorCount}条数据未导入`);
            } else {
              this.visible = false;
              this.$notice.success(`系统已成功导入${res.data.successCount}条数据`);
            }
            this.$emit('success');
          }
        })
        .finally(() => {
          this.loading = false;
        });

      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import './importCommission.scss';
</style>
